import { useQuery } from 'react-query';

import { Menu } from '../../type';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';


export const getLiveMenu = async (): Promise<Menu[]> => {
    const { data } = await axios.get(`v1/get-menu-live`);
    return data.giftcards;
};

type QueryFnType = typeof getLiveMenu;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useMenu = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['menu'],
        queryFn: () => getLiveMenu(),
    });
};
